import moment from "moment"

export const sessionNextToExpire = (expiration) => {
  const tokenExpireDate = moment.unix(expiration)
  if (tokenExpireDate.diff(moment(), 'days') < 7) {
    return true
  }
  return false
}